var $24ebda9c775dca17$exports = {};
$24ebda9c775dca17$exports = {
    "longPressMessage": `Langt tryk eller tryk p\xe5 Alt + pil ned for at \xe5bne menuen`
};


export {$24ebda9c775dca17$exports as default};
//# sourceMappingURL=da-DK.mjs.map
